import script from "./BookingSubMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingSubMenu.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__